import RoleGuard from "@/components/common/RoleGuard/RoleGuard.vue";

export default [
  {
    path: "/Setup",
    component: RoleGuard,
    props: {
      allowedRoles: ["ADMINISTRATOR"],
      redirectPath: "/",
    },
    children: [
      /** addon 서비스 리스트 */
      {
        path: "addonservice",
        name: "AddonServiceListPage",
        component: () =>
          import("../pages/addonService/AddonServiceListPage.vue"),
      },

      /** addon 서비스 생성 */
      {
        path: "addonService/create",
        name: "AddonServiceCreate",
        component: () =>
          import("../pages/addonService/AddonServiceCreatePage.vue"),
        meta: {
          type: "create",
        },
      },
      /** addon 서비스 상세 */
      {
        path: "addonService/:addonServiceId",
        name: "AddonServiceDetailPage",
        component: () =>
          import("../pages/addonService/AddonServiceDetailPage.vue"),
      },
    ],
  },
];
